'use strict';

// this file was created to prevent NativeReanimated from being included in the web bundle
import { createJSReanimatedModule } from "./js-reanimated/index.js";
export const ReanimatedModule = createJSReanimatedModule();
//# sourceMappingURL=index.js.map